<template>
    <div class="component__settings_header">
        <div class="box__icon--settings" @click="handleClickSettings">
            <div class="icon--settings">
                <img
                    src="/images/_SVGs/chart.svg"
                    onload="SVGInject(this)"
                    width="100%"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
      isBackoffice: { type: Boolean, default: false, require: false }
    },

    data() {
        return {
            settingsComponent: {},
        };
    },

    computed: {
        userAuthCheck() {
            return !!(this.$store.getters["auth/getState"].acceptedTerms &&
                this.$store.getters["auth/getState"].token);

        },
    },

    methods: {
        handleClickSettings() {
            if (this.userAuthCheck) {

                let hasParams = null;
                if (this.$route.params && Object.keys(this.$route.params).length > 0) {
                  hasParams = this.$route.params;
                }
                const currentPath = this.$route.name;
                if(this.isBackoffice && this.$route.name != "backoffice-user-consumption") {
                  this.$router.push({ name: "backoffice-user-consumption", params: { lastPath: currentPath, ...hasParams } });
                }
                if (!this.isBackoffice && this.$route.name != "user-consumption") {
                    this.$router.push({ name: "user-consumption", params: { lastPath: currentPath, ...hasParams } });
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

.component__settings_header {
    cursor: pointer;
    .icon--settings {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--v-primary-base) !important;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        svg {
            .st0 {
                fill: var(--v-primary-base) !important;
            }
            g {
                circle {
                    stroke: #fff !important;
                }
                g {
                    g {
                        path {
                            stroke: #fff !important;

                            .st2 {
                                fill: #fff !important;
                            }
                        }
                    }
                }
            }
        }

        &:hover,
        &.active {
            background-color: var(--v-primary-darken1) !important;
            svg {
                g {
                    circle {
                        fill: var(--v-primary-darken1) !important;
                    }
                }
            }
            .shoppingcart--numero {
                background: #f59534;
            }
        }
    }
}
</style>
